import { useEffect, useState } from 'react';
import List from './list';
import Report from './report';
import _ from 'lodash';
import WeekdaysApi from '../../../api/weekdays.api';
import TermPlanApi from '../../../api/term-plan.api';
import TermApi from '../../../api/term.api';
import { useAppDispatch, useAppSelector } from '../../../hooks/hooks';
import { setPlan, setState } from '../../../store/reducers/term-planner';
import {toast} from "react-toastify";

const TermPlanner = (props: any) => {
    const _termApi = new TermApi();
    const _termPlannerApi = new TermPlanApi();
    const _weekDaysApi = new WeekdaysApi();

    const appState = useAppSelector((state) => state.appState);
    const termPlannerState = useAppSelector((state) => state.termPlanner);


    const dispatch = useAppDispatch();

    const [step, setStep] = useState(1);

    useEffect(() => {
        const loadData = async (campusId: number) => {
            const weekdays = await _weekDaysApi.GetAll();
            const terms = await _termApi.GetTermsByCampusId(campusId);
            const termPlans = await _termPlannerApi.GetAll();
            const statuses = await _termPlannerApi.GetStatuses();

            dispatch(
                setState({
                    terms,
                    weekdays,
                    termPlans,
                    termPlan: null,
                    statuses,
                }),
            );
        };

        if (appState.campus?.id) {
            loadData(appState.campus.id).catch((error) => toast.error(error));
        }
    }, [appState]);

    const handleGenerateReport = async (term: any, weekday: any, type: string) => {
        const termPlan = await _termPlannerApi.Generate(term?.termCampusId, weekday.id, type);

        dispatch(setPlan(termPlan));

        dispatch(
            setState({
                terms: termPlannerState.terms,
                weekdays: termPlannerState.weekdays,
                //TODO: is this really the best way to update array of plans
                termPlans: [termPlan, ...termPlannerState.termPlans],
                termPlan: termPlan,
                statuses: termPlannerState.statuses,
            }),
        );

        setStep(2);
    };

    const handleLoadPlan = (termPlan: any) => {
        dispatch(setPlan(termPlan));
        setStep(2);
    };

    //TODO: is cloning the best way to mutate state?
    const handleClose = () => {
        const termPlans = _.cloneDeep(termPlannerState.termPlans);
        const termPlan = _.cloneDeep(termPlannerState.termPlan);

        const termPlanIndex = termPlans.findIndex((t) => t.id == termPlan.id);

        if (termPlanIndex) {
            termPlans[termPlanIndex] = termPlan;
        }

        dispatch(
            setState({
                terms: termPlannerState.terms,
                weekdays: termPlannerState.weekdays,
                termPlans: termPlans,
                termPlan: undefined,
                statuses: termPlannerState.statuses,
            }),
        );

        setStep(1);
    };

    const renderPage = () => {
        switch (step) {
            case 1:
                return <List onGenerate={handleGenerateReport} onLoadPlan={handleLoadPlan} />;

            case 2:
                return <Report onClose={handleClose} />;
        }
    };

    return <>{renderPage()}</>;
};

export default TermPlanner;
